import { Eye } from 'lucide-react'

interface VisitorBadgeProps {
  count?: number
}

export function VisitorBadge({ count }: VisitorBadgeProps) {
  if (!count || count <= 0) return null

  return (
    <span className="inline-flex items-center gap-0.5 text-xs text-muted-foreground" title={`${count} visits (30d)`}>
      <Eye className="w-3 h-3" />
      {count}
    </span>
  )
}
